import { fadeInOut } from '../../services/animations';
import { Component, Input, AfterViewInit, ViewContainerRef, ViewChildren, ComponentFactory, Type, NgModule, QueryList, ViewEncapsulation, ElementRef, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { takeWhile } from 'rxjs/operators';
declare var $: any;
import { Programme } from '../../models/programme.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgrammesService } from '../../services/programmes.service';
import { TableauxService } from '../../services/tableaux.service';
import { Tableau } from '../../models/tableau.model';
import { EquivalencesModalComponent } from './modal/equivalences.modal.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-tableaux-sous-programmes',
  templateUrl: './tableaux.component.html',
  styleUrls: ['./tableaux.component.scss'],
  animations: [fadeInOut],
})

export class TableauxComponent implements OnInit, AfterViewInit {
  @ViewChildren('programmeRow', { read: ViewContainerRef }) children: QueryList<ViewContainerRef>;
  @Input() sousprogrammes: Array<Programme>;
  @Input() programme: Programme;
  form: FormGroup;
  bsModalRef: BsModalRef;
  myEventSubscription: any;
  tableau: Tableau;
  tableauInverse: Tableau;
  programmesSansTableaux: Array<Programme>;
  newProgrammeAreaVisible: boolean = false;
  isNewTableau: boolean = false;
  public loading: boolean = false;
  public afficherTableau: boolean = false;
  public afficherTableauInverse: boolean = false;
  public equivalenceFirst: number;
  public equivalenceLast: number;
  routeToRead: boolean = true;
  private sub: any;
  isUserLoggedIn: boolean;
  private sousProgrammeActif: number;

  constructor(
    fb: FormBuilder,
    private progservice: ProgrammesService,
    private tabservice: TableauxService,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private authService: AuthService,
    private modalService: BsModalService) {
    this.form = fb.group({
      "tableauId": [""],
      "fromProgrammeId": [-1, Validators.required],
      "toProgrammeId": [-1],
      "notes": [""],
      "equivalences": [],
      "newProgrammeSelect": []
    });
  }


  ngOnInit(): void {
    this.isUserLoggedIn = this.authService.isLoggedIn;
    this.afficherTableau = false;
    this.afficherTableauInverse = false;
    this.tableau = {
      tableauId: -1,
      fromProgrammeId: -1,
      toProgrammeId: -1,
      notes: '',
      equivalences: [],
    };
    this.tableauInverse = {
      tableauId: -1,
      fromProgrammeId: -1,
      toProgrammeId: -1,
      notes: '',
      equivalences: [],
    };
  }

  ngAfterViewInit(): void {
    //this.loadSousprogrammes();
  }

  //loadSousprogrammes(): void {
  //  if (this.sousprogrammes != undefined) {
  //    this.sousprogrammes.forEach((sousprogramme) => {
  //      const el: any = this.children.find(x => x.element.nativeElement.id === 'collapseSousprogramme' + sousprogramme.programmeId);
  //      const element: any = ($(el.element.nativeElement) as any);
  //      element.collapse('show');
  //    });
  //  }
  //}

  updateTableau() {
    this.tabservice.updateTableau(this.tableau.tableauId, this.tableau).subscribe(() => {
      this.loading = false;
      this.form.markAsPristine();
    });
  }

  openModalEquivalence(sousprogramme: Programme) {
    let initialState = {
      tableauId: this.tableau.tableauId,
      fromProgrammeId: this.programme.programmeId,
      fromProgrammeName: this.programme.nom,
      fromProgrammeCode: this.programme.code,
      toProgrammeId: sousprogramme.programmeId,
      toProgrammeName: sousprogramme.nom,
      toProgrammeCode: sousprogramme.code
    };

    this.bsModalRef = this.modalService.show(EquivalencesModalComponent, {
      initialState: initialState,
      class: 'gray modal-lg',
      ignoreBackdropClick: true
    });
    this.myEventSubscription =
      this.modalService.onHide.subscribe(() => {
        this.loadTableau(this.programme.programmeId, this.tableau.toProgrammeId, true);
      });
  }

  equivalencesChanged(params: string) {
    // params : "equivalenceId|action" (action == UP DOWN ou DELETE)
    this.tabservice.changeEquivalence(params).subscribe(() => {
      this.loadTableau(this.tableau.fromProgrammeId, this.tableau.toProgrammeId, true);
    });
  }

  loadTableau(fromProgrammeId: number, toProgrammeId: number, equivChanged: boolean) {
    if (!equivChanged) {
      if (this.sousProgrammeActif == toProgrammeId) {
        ($(`div:not(#collapseSousprogramme${toProgrammeId})[data-parent="#accordion-sousprogramme"]`)).collapse('hide');
        return;
      }
      else {
        if (this.sousProgrammeActif != undefined) {
          ($(`div:not(#collapseSousprogramme${this.sousProgrammeActif})[data-parent="#accordion-sousprogramme"]`)).collapse('hide');
          ($(`div:not(#collapseSousprogramme${toProgrammeId})[data-parent="#accordion-sousprogramme"]`)).collapse('hide');
        }
        //($(`div:not(#collapseSousprogramme${toProgrammeId})[data-parent="#accordion-sousprogramme"]`)).collapse('hide');
        this.sousProgrammeActif = toProgrammeId;
      }
    }
    

    this.afficherTableau = false;
    this.afficherTableauInverse = false;
    this.tabservice.getTableau(fromProgrammeId, toProgrammeId).subscribe(res => {
      this.tableau = res;
      this.afficherTableau = true;
      this.form.markAsPristine();
      // setup premier et dernier equivalence
      if (this.tableau.equivalences != null) {
        this.equivalenceFirst = this.tableau.equivalences[0].equivalenceId;
        this.equivalenceLast = this.tableau.equivalences[this.tableau.equivalences.length - 1].equivalenceId;
      }
      this.tabservice.getTableau(toProgrammeId, fromProgrammeId).subscribe(res => {
        if (res != null) {
          this.tableauInverse = res;
          this.afficherTableauInverse = true;
        }
      });
    });
  }

  ajouterProgramme() {
    this.loading = true;
    this.afficherTableau = false;
    this.progservice.getProgrammesSansTableaux(this.programme.programmeId).subscribe(res => {
      this.programmesSansTableaux = res;
      this.form.controls.newProgrammeSelect.setValue(null);
      this.loading = false;
      this.isNewTableau = true;
      this.newProgrammeAreaVisible = true;
    });
  }

  ajouterProgrammeCancel() {
    this.newProgrammeAreaVisible = false;
  }

  creerTableau() {
    this.tableau = new Tableau();
    this.tableau.tableauId = -1;
    this.tableau.notes = "";
    this.tableau.fromProgrammeId = this.programme.programmeId;
    this.tableau.toProgrammeId = this.form.controls.newProgrammeSelect.value;
    this.tabservice.createTableau(this.tableau).subscribe(res => {
      this.progservice.getAllProgrammesAvecTableaux(this.programme.programmeId).subscribe(res => {
        this.afficherTableau = false;
        this.newProgrammeAreaVisible = false;
        this.sousprogrammes = res;
      });
    })
  }

  printTableau() {
    window.print();
  }

  supprimerTableau(fromProgrammeId: number, toProgrammeId: number) {
    this.tabservice.getTableau(fromProgrammeId, toProgrammeId).subscribe(res => {
      this.tableau = res;
      if (this.tableau.equivalences != null) {
        alert("\r\nAttention!\r\nSeuls les tableaux qui n’ont pas d’équivalences peuvent être supprimés.");
      }
      else {
        this.tabservice.deleteTableau(this.tableau).subscribe(res => {
          this.progservice.getAllProgrammesAvecTableaux(this.programme.programmeId).subscribe(res => {
            this.afficherTableau = false;
            this.newProgrammeAreaVisible = false;
            this.sousprogrammes = res;
            this.loading = false;
          });
        });
      }

    })
  }

  isSousprogrammes(): boolean {
    var returnValue = false;
    if (this.sousprogrammes != null) {
      if (this.sousprogrammes.length > 0)
        returnValue = true;
    }
    return returnValue;
  }

  isNewProgrammeSelected(): boolean {
    var returnValue = false;
    if (this.form.controls.newProgrammeSelect.value != null) {
      returnValue = true;
    }
    return returnValue;
  }

}
